import styled from '@emotion/styled';
import DepartureIcon from '../../../../../assets/icons/flights/plane-departure.svg';
import ArrivalIcon from '../../../../../assets/icons/flights/plane-arrival.svg';
import { Css } from '../../../../../ui';

interface IArrivalDepartureCellProps {
	arrival: boolean;
}

export function ArrivalDepartureCell({ arrival }: IArrivalDepartureCellProps) {
	const icon = arrival ? <ArrivalIcon /> : <DepartureIcon />;
	const text = arrival ? 'Arrival' : 'Departure';
	return (
		<StyledArrivalDepartureCell>
			{icon} {text}
		</StyledArrivalDepartureCell>
	);
}

const StyledArrivalDepartureCell = styled.div`
	display: flex;
	gap: ${Css.pxToRem(16)};
`;
